import React from 'react'
import Text from '../../../../components/Text'
import Card from '../../../../components/Card'
import cx from 'classnames'
import styles from './CreateFontCard.module.css'
import CreateFontModal from '../CreateFontModal/CreateFontModal'
import { openModal } from '../../../../services/ModalService'
import { Font } from '../../../../types/Font'
import { useTranslation } from 'react-i18next'

const CreateFontCard: React.FC<{ fonts: Font[]; onCreate: () => void }> = ({
    fonts,
    onCreate,
}) => {
    const { t } = useTranslation('settings')

    const openCreateModal = () => {
        const content: JSX.Element = (
            <CreateFontModal fonts={fonts} onSubmit={() => onCreate()} />
        )
        openModal({
            heading: t('fonts.create_modal.heading'),
            content: content,
        })
    }

    return (
        <Card classes={cx(styles['card-wrapper'])}>
            <div
                className={cx(styles['card-inner-wrapper'])}
                onClick={() => openCreateModal()}
            >
                <div className={cx(styles['card-plus'])}>+</div>
                <Text classes={'text-center'}>{t('fonts.add_font')}</Text>
            </div>
        </Card>
    )
}

export default CreateFontCard
